export default __webpack_public_path__ + "static/Bg_gradient_paler-959b5156a079c7cc8028a51f16b0b88c.png";